import type { BubblyItem } from "@lr-notitia/bubbly-d3";

export function flattenStructure(bubbly: BubblyItem):Array<BubblyItem & {path:string[]}> {
  let flattened:Array<BubblyItem & {path:string[]}> = []

  function recurse(item: BubblyItem, path: string[]) {
    if (!item.children || item.children.length === 0) {
      flattened.push({ ...item, path: [...path, item.name] });
    } else {
      item.children.forEach(child => recurse(child, [...path, item.name]));
    }
  }

  recurse(bubbly, []);

  return flattened 
}